module.exports = __webpack_public_path__ + "static/media/cats.ca7f07ad.png";